/**
 * Current User Vuex
 */
import Cons from '@/constants.json'
import * as API from '@/endpoints'

import VueCookie from 'vue-cookie'
import Axios from 'axios'
import Vue from 'vue'
import {Message} from 'iview'
import router from '@/router'
import _ from 'lodash';

import axiosRetry from 'axios-retry';

axiosRetry(Axios, { retries: 0 });

export default {
  namespaced: true,
  state: {
    careteam: {},
    careteamgroups: {},
    isLoadingCareteam: false,
    isLoadingAddCareteam: false,
    isLoadingCareteamGroup: false,
    isLoadingBrandUsers: false,
    isLoadingKickCareteam: false,
    loadingBrandingData: false,
    info: {},
    infoIsLoading: false,
    brand: {},
    brandPlan: {},
    brandCategory:{},
    brandContacts:[],
    feed: {
      list: {},
      isLoading: false
    },
    journalFeed: {
      list: {},
      isLoading: false
    },
    brands: {
      data: {},
      isLoading: false
    },
    invitations: {
      data: {},
      prescription: {},
      isLoading: false
    },
    profanity: {
      data: {},
      isLoading: false
    },
    reportCategory: {
      data:{},
      isLoading: false
    },
    category : {
      concern: { data:{}, isLoading: false },
      suggestion: { data:{}, isLoading: false },
      heroes: { data:{}, isLoading: false }
    },
    invite : {
      showInviteModal: false,
      shareFbUrl : ''
    },
    userFields: {},
    publicProfile: {},
    userBookmarks: {},
    userStuffs: {},
    isLoadingBookmark: false,
    isLoadingUserProfile: false,
    isLoadingBrandInfo: false,
    showOnboardingModal: false,
    showVerifyModal: false,
    isLoadingLoadMore: false,
    isLoadingSearch: false,
    isLoadingUserStuffs: false,
    isLoadingReporting: false,
    avatars: {},
    isLoadingUserAvatar: false,
    locationLoader: false,
    advocacies: {},
    resrouceByType:{
      alliance: {careplan:[]},
      interest: {careplan:[]},
      special_project: {careplan:[]},
      any: {careplan:[]},
      public: {careplan:[]}
    },
    pendingAdvocacies: {},
    showStepsUser: false,
    showStepsActivity: false,
    showStepsComment: false,
    reportThisId: '',
    countFeedList: 0,
    countUserStuffs: 0,
    isStuffLoading: false,
    upcommingActivities: [],
    leadership: {},
    nearby:{
      country:{},
      province:{},
      city:{}
    },
    documents: {
      isLoading: false,
      data: {},
      category : {},
      updatedItem: {},
      isSubmitLoading: false,
      choices: []
    },
    consent:{
      email:null,
      user_agree:false
    }
  },
  getters: {
    isAllowPoints: state => state.brand.allow_points,
    isHomeFeedLoading(state) { 
      return _.get(state.feed, 'isLoading')
    },
    activityList: state => _.get(state.feed, 'list.items'),
    isBroadcast: state => state.brand.broadcast,
    careteamlist: state => state.careteam,
    careteamgroupsitem: state => state.careteamgroups,
    isLoadingCareteamGroup: state => state.isLoadingCareteamGroup,
    isLoadingCareteamlist: state => state.isLoadingCareteam,
    isLoadingAddCareteam: state => state.isLoadingAddCareteam,
    isLoadingBrandUsers: state => state.isLoadingBrandUsers,
    isLoadingKickCareteam: state => state.isLoadingKickCareteam,
    isLoadingBrandTheme: state => state.loadingBrandingData,
    brandInfo: state => state.brand,
    userInfo: (state) => {
      return state.info;
    },
    newActivities: (state) => {
      return state.upcommingActivities.length > 0
    },
    lastLatestActivity: (state) => {
      return _.orderBy(state.feed.list.items, 'rrule_parsed_date', 'desc')[0]
    },
    findActivity(state) {
      return id => state.feed.list.items.find( (i) => {
        return i.id === id
      });
    },
    onboarding: (state) => {
      let obj = {
        gender: null,
        meta: {}
      }
      return Object.assign(obj, state.info)
    },
    getTheme(state) {
      return state.brand.theme
    },
    brandCategories(state){
      return state.brandCategory
    },
    brandContacts(state){
      return state.brandContacts
    },
    consent(state){
      return state.consent
    }
  },
  mutations: {
    updateDocument(state, v){
      if (state.documents.data.careplan_item && state.documents.data.careplan_item.length > 0)
        return

      let foundInStack = state.documents.data.careplan_item.findIndex( (i) => {
        return i.id === v.id
      });

      if(foundInStack != -1){
        state.documents.data.careplan_item[foundInStack] = v
      }
    },
    setCategoryUpdateLoading(state, v){
      Vue.set(state.documents, 'isSubmitLoading', v)
    },
    setCategoryDataConcern(state, v) {
      Vue.set(state.category.concern,'data',v);
    },
    setCategoryIsLoadingConcern(state, v) {
      Vue.set(state.category.concern,'isLoading',v);
    },
    setCategoryDataSuggestion(state, v) {
      Vue.set(state.category.suggestion,'data',v);
    },
    setCategoryIsLoadingSuggestion(state, v) {
      Vue.set(state.category.suggestion,'isLoading',v);
    },
    setCategoryDataHeroes(state, v) {
      Vue.set(state.category.heroes,'data',v);
    },
    setCategoryIsLoadingHeroes(state, v) {
      Vue.set(state.category.heroes,'isLoading',v);
    },
    setReportCategory(state, v) {
      Vue.set(state.reportCategory,'data', v);
    },
    setIsLoadingReportCategory(state, v) {
      Vue.set(state.reportCategory, 'isLoading', v);
    },
    setProfanity(state, v) {
      Vue.set(state.profanity, 'data', v);
    },
    setIsLoadingProfanity(state, v) {
      Vue.set(state.profanity,'isLoading', v);
    },
    applyUpcommingToFeed(state) {
      for ( let x=0; x< state.upcommingActivities.length; x++ ) {
        if('group' in state.upcommingActivities[x] ) {
          state.upcommingActivities[x].careplan = state.upcommingActivities[x].group
        }

        state.feed.list.items.unshift( state.upcommingActivities[x] )
      }
      Vue.set(state, 'upcommingActivities', []);
    },
    addUserResources(state, v) {
      let foundInStack = state.feed.list.items.find( (i) => {
        return i.id === v.id
      });
      if( !foundInStack ) state.feed.list.items.unshift(v);
    },
    addNewActivity(state, v) {
      let foundInStack = state.upcommingActivities.find( (i) => {
        return i.id === v.id
      });

      if( !foundInStack ) state.upcommingActivities.push(v);
    },
    removeActivity(state, v) {
      let foundInStack = state.feed.list.items.findIndex( (i) => {
        return i.id === v
      });
      if(foundInStack != -1){
        state.feed.list.items.splice(foundInStack,1);
      }
    },
    resetCurrentUser(state) {
      Vue.set(state.journalFeed, 'list', {});
      Vue.set(state.journalFeed, 'isLoading', false);
      Vue.set(state, 'userStuffs', {});
      Vue.set(state.invitations, 'data', {});
      Vue.set(state.invitations, 'prescription', {});
      Vue.set(state.invitations, 'isLoading', false);
    },
    setCountUserStuffs(state, v) {
      Vue.set(state, 'countUserStuffs', v)
    },
    setCountFeedList(state, v) {
      Vue.set(state, 'countFeedList',v)
    },
    setReportThisId(state, v) {
      Vue.set(state, 'reportThisId',v)
    },
    setShowStepsComment(state, v) {
      Vue.set(state,'showStepsComment',v)
    },
    setShowStepsUser(state, v) {
      Vue.set(state, 'showStepsUser', v)
    },
    setShowStepsActivity(state, v) {
      Vue.set(state, 'showStepsActivity', v)
    },
    setAdvocacies(state, v) {
      Vue.set(state, 'advocacies', v)
    },
    setResourcesByType(state, v) {
      switch(v.type) {
        case 'alliance':
          Vue.set(state.resrouceByType, 'alliance', v.data)
          break;
        case 'interest':
          Vue.set(state.resrouceByType, 'interest', v.data)
          break;
        case 'special_project':
          Vue.set(state.resrouceByType, 'special_project', v.data)
          break;
        default:
          Vue.set(state.resrouceByType, 'any', {careplan: []})
          Vue.set(state.resrouceByType, 'any', v.data)
          break;
      }
    },
    setPendingAdvocacies(state, v) {
      Vue.set(state, 'pendingAdvocacies', v)
    },
    setImageLibraries(state, v) {
      Vue.set(state, 'avatars', v)
    },
    setUserManageBrand (state, v) {
      Vue.set(state.brands, 'data', v)
    },
    setUserManageBrandLoading (state, v) {
      Vue.set(state.brands, 'isLoading', v)
    },
    setInfoLoader (state, v) {
      Vue.set(state, 'infoIsLoading', v)
    },
    setPrescription (state, v) {
      Vue.set(state.invitations, 'prescription', v)
    },
    setInvitations (state, v) {
      Vue.set(state.invitations, 'data', v)
    },
    setInvitationsLoader (state, v) {
      Vue.set(state.invitations, 'isLoading', v)
    },
    showOnboardingModal (state, v) {
      Vue.set(state, 'showOnboardingModal', v)
    },showVerifyModal (state, v) {
      Vue.set(state, 'showVerifyModal', v)
    },showInviteModal (state, v) {
      Vue.set(state.invite, 'showInviteModal', v.showInvite)
      Vue.set(state.invite, 'shareFbUrl', v.fbShareUrl)
    },
    setIsLoadingBrandInfo (state, v) {
      Vue.set(state, 'isLoadingBrandInfo', v)
    },
    setIsLoadingBookmark (state, v) {
      Vue.set(state, 'isLoadingBookmark', v)
    },
    setBookmarkId (state, v) {
      Vue.set(state.publicProfile, 'bookmark_id', v)
    },
    setPublicProfileBookmark (state, v) {
      Vue.set(state.publicProfile, 'bookmarked', !!v)
    },
    setPublicProfile (state, v) {
      Vue.set(state, 'publicProfile', v)
      Vue.set(state.publicProfile, 'bookmarked', !!v.bookmarked)
    },
    setUserInfo (state, v) {
      Vue.set(state, 'info', v)
    },
    setUserBrand (state, v) {
      state.brand = v;
    },
    setUserBrandPlan (state, v) {
      Vue.set(state, 'brandPlan', v)
    },
    setStuffMore(state, v) {
      state.userStuffs.careplans.next_link = v.next_link
      for (var x = 0; x < v.careplans.length; x++) {
        state.userStuffs.careplans.push(v.items[x])
      }
    },
    setStuffLoader (state, v) {
      Vue.set(state, 'isStuffLoading', v)
    },
    setUserFeedMore (state, v) {
      state.feed.list.next_link = v.next_link
      for (var x = 0; x < v.items.length; x++) {
        state.feed.list.items.push(v.items[x])
      }
    },
    setUserJournalFeedMore (state, v) {
      state.journalFeed.list.next_link = v.next_link
      for (var x = 0; x < v.careplan_item.length; x++) {
        state.journalFeed.list.careplan_item.push(v.careplan_item[x])
      }
    },
    setUserFeed (state, v) {
      Vue.set(state.feed, 'list', v)
    },
    setUserFeedLoader (state, v) {
      Vue.set(state.feed, 'isLoading', v)
    },
    setUserJournalFeed (state, v) {
      Vue.set(state.journalFeed, 'list', v)
    },
    setUserJournalFeedLoader (state, v) {
      Vue.set(state.journalFeed, 'isLoading', v)
    },
    setUserFields (state, v) {
      if (!v[0]) return

      var fields = v[0].fields

      if(v[1]) {
        for(let x=0; x<v[1].fields.length; x++) {
          fields.push(v[1].fields[x])
        }
      }

      Vue.set(state, 'userFields', fields)
    },
    setIsLoadingUserProfile (state, v) {
      Vue.set(state, 'isLoadingUserProfile', v)
    },
    setUserBookmark (state, v) {
      Vue.set(state, 'userBookmarks', v)
    },
    setUserStuffs (state, v) {
      Vue.set(state, 'userStuffs', v)
    },
    pushUserBookmarks (state, v) {
      for (let i = 0; i < v.data.length; i++) {
        state.userBookmarks.data.push(v.data[i])
      }
      state.userBookmarks.next_link = v.next_link
    },
    pushUserStuffs (state, v) {
      for (let i = 0; i < v.careplans.length; i++) {
        state.userStuffs.careplans.push(v.careplans[i])
      }
      state.userStuffs.next_link = v.next_link
    },
    setLoadingLoadMore (state, v) {
      Vue.set(state, 'isLoadingLoadMore', v)
    },
    setLoadingSearch (state, v) {
      Vue.set(state, 'isLoadingSearch', v)
    },
    setLoadingUserStuffs(state, v) {
      Vue.set(state, 'isLoadingUserStuffs', v)
    },
    updateUserAvatar(state, v) {
      Vue.set(state.info, "avatar", v);
    },
    updateUserAvatarUri(state, v) {
      Vue.set(state.info, "avatar_uri", v);
    },
    setLoadingUserAvatar(state, v) {
      Vue.set(state, "isLoadingUserAvatar", v);
    },
    setLoadingReporting(state, v) {
      Vue.set(state, 'isLoadingReporting', v);
    },
    removeUserField(state, v) {
      if (!_.isEmpty(state.userFields)) {
        for (let i = v.length -1; i >= 0; i--)
          state.userFields.splice(v[i],1);
      }
    },
    setLocationLoader(state, v) {
      Vue.set(state, "locationLoader", v);
    },
    setWorkLocation(state, v) {
      if (_.get(state.info, "places") && state.info.places.work) {
        Vue.set(state.info.places.work, "latitude", v.latitude);
        Vue.set(state.info.places.work, "longitude", v.longitude);
      }
    },
    setHomeLocation(state, v) {
      if (_.get(state.info, "places") && state.info.places.home) {
        Vue.set(state.info.places.home, "latitude", v.latitude);
        Vue.set(state.info.places.home, "longitude", v.longitude);
      }
    },
    setNearbyCity(state, v) {
      Vue.set(state.nearby,"city",v);
    },setNearbyCountry(state, v) {
      Vue.set(state.nearby,"country",v);
    },setNearbyProvince(state, v) {
      Vue.set(state.nearby,"province",v);
    },
    setDocuments(state,v){
      Vue.set(state.documents,'data', v)
    },
    isDocumentsLoading(state, v){
      Vue.set(state.documents, 'isLoading', v)
    },
    setUpdatedItem(state, v){
      Vue.set(state.documents, 'updatedItem', v)
    },
    setDocumentCategoryChoices(state, v){
      Vue.set(state.documents, 'choices', v)
    },
    setBrandContacts(state, v){
      Vue.set(state, 'brandContacts', v)
    },
    setConsent(state,v){
      Vue.set(state, 'consent', v)
    }
  },
  actions: {
    setPrimaryMobile({ }, mobile) {
      return Axios.put(API.endpoints.base + "mobile", {
        mobile: mobile
      }).then(res => {
        return Promise.resolve(res.data)
      }, error => {
        return Promise.reject(error);
      })
    },
    setPrimaryEmail({ }, email) {
      return Axios.put(API.endpoints.base + "user/email/primary", {
        email: email
      }).then(res => {
        return Promise.resolve(res.data)
      }, error => {
        return Promise.reject(error);
      })
    },
    verifyCode({ }, code) {
      return Axios.post(API.endpoints.base + "user/validate/code", {
        code: code
      }).then(res => {
        return Promise.resolve(res.data)
      }, error => {
        return Promise.reject(error);
      })
    },
    emailSendCode({ }, email) {
      return Axios.post(API.endpoints.base + "user/email/activate/resend", {
        email: email
      }).then(res => {
        return Promise.resolve(res.data)
      }).catch( err => {
        return Promise.reject(err);
      })
    },
    deleteEmail({ }, email) {
      return Axios.delete(API.endpoints.base + "user/remove/email?email=" + encodeURIComponent(email))
      .then(res => {
        return Promise.resolve(res.data)
      }).catch( err => {
        return Promise.reject(err);
      })
    },
    addEmail({ }, email) {
      return Axios.post(API.endpoints.base + "user/add/email", {
        email: email
      }).then(res => {
        return Promise.resolve(res.data)
      }).catch( err => {
        return Promise.reject(err);
      })
    },
    mobileSendCode({ }, mobile) {
      return Axios.post(API.endpoints.base + "mobile/resend/code", {
        mobile: mobile
      }).then(res => {
        return Promise.resolve(res.data)
      }).catch( err => {
        return Promise.reject(err);
      })
    },
    addMobile({ }, payload) {
      return Axios.post(API.endpoints.base + "mobile", {
        mobile: payload.mobile,
        primary: payload.primary || 0
      }).then(res => {
        return Promise.resolve(res.data)
      }).catch( err => {
        return Promise.reject(err);
      })
    },
    deleteMobile({ }, mobile) {
      return Axios.delete(API.endpoints.base + "mobile?mobile=" + encodeURIComponent(mobile))
      .then(res => {
        return Promise.resolve(res.data)
      }).catch( err => {
        return Promise.reject(err);
      })
    },
    getRegistrationKey(context, payload) {
      return Axios.get(API.endpoints.base + "user/get/bykey?key="+payload.key).then(res => {
        return Promise.resolve(res.data)
      }).catch( err => {
        return Promise.reject(err);
      })
    },
    verification(context, payload) {
      return Axios.post(API.endpoints.base + "user/email/send/verification", payload).then(res => {
        return Promise.resolve(res.data)
      }).catch( err => {
        return Promise.reject(err);
      })
    },
    category({dispatch, commit, state}) {
      return new Promise((resolve, reject)=> {
        Promise.all([
          dispatch('categoryConcern'),
          dispatch('categorySuggestion'),
          dispatch('categoryHeroes')
        ])
          .then(function(values) {
            resolve(values);
          })
          .catch(function(error) {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          });
      });
    },
    categoryConcern({dispatch, commit, state}) {
      return new Promise((resolve,reject)=>{
        commit('setCategoryIsLoadingConcern',true);
        Axios.get(API.endpoints.field + '/concern_category').then(
          res=>{
            commit('setCategoryIsLoadingConcern',false);
            commit('setCategoryDataConcern', res.data);
            resolve(res.data);
          },
          error=>{
            commit('setCategoryIsLoadingConcern',false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    categorySuggestion({dispatch, commit, state}) {
      return new Promise((resolve,reject)=>{
        commit('setCategoryIsLoadingSuggestion',true);
        Axios.get(API.endpoints.field + '/suggestion_category').then(
          res=>{
            commit('setCategoryIsLoadingSuggestion',false);
            commit('setCategoryDataSuggestion', res.data);
            resolve(res.data);
          },
          error=>{
            commit('setCategoryIsLoadingSuggestion',false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    categoryHeroes({dispatch, commit, state}) {
      return new Promise((resolve,reject)=>{
        commit('setCategoryIsLoadingHeroes',true);
        Axios.get(API.endpoints.field + '/heroes_category').then(
          res=>{
            commit('setCategoryIsLoadingHeroes',false);
            commit('setCategoryDataHeroes', res.data);
            resolve(res.data);
          },
          error=>{
            commit('setCategoryIsLoadingHeroes',false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    getSpecial({ dispatch, commit, state}) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/'+Cons[0].GROUP_ID.leadership).then(
          res=> {
            state.leadership = res.data
            resolve(res.data);
          },
          error=> {
            reject(error);
          }
        );
      });
    },
    reportCategory({ dispatch, commit, state}) {
      return new Promise((resolve, reject) => {
        commit('setIsLoadingReportCategory', true);
        Axios.get(API.endpoints.field + '/report_category').then(
          res=> {
            commit('setReportCategory', res.data);
            commit('setIsLoadingReportCategory', false);
            resolve(res.data);
          },
          error=> {
            commit('setIsLoadingReportCategory', false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    profanity({ dispatch, commit, state}) {
      return new Promise((resolve, reject) => {
        commit('setIsLoadingProfanity', true);
        Axios.get(API.endpoints.profanity + '/words', { page:1, per_page: 1000 }).then(
          res=> {
            console.log('profanity...', res.data);
            commit('setProfanity', res.data);
            commit('setIsLoadingProfanity', false);
            resolve(res.data);
          },
          error=> {
            commit('setIsLoadingProfanity', false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    resetPassword({ dispatch, commit, state}, v) {
      return new Promise((resolve, reject) => {
        var param = {
          key: v.key,
          user_id: v.user_id,
          new_password: v.new_password
        };
        // console.log("Reset password", param);
        // return;
        Axios.post(API.endpoints.password + '/reset', param).then(
          res => {
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    forgotPasswordViaMobile({ dispatch, commit, state}, mobile) {
      console.log("forgotPasswordViaMobile...", mobile);
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.password + '/request', { 'mobile': mobile, brand_id: Cons[0].BRAND_ID} ).then(
          res => {
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    forgotPasswordViaEmail({ dispatch, commit, state}, email) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.password + '/request', {
          "email": email,
          "brand_id": Cons[0].BRAND_ID
        }).then(
          res => {
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    changePassword({ dispatch, commit, state}, {oldPassword, newPassword}) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.user + '/changepass', {"old_pass": oldPassword, "new_pass": newPassword}).then(
          res => {
            if(res.data.success) {
              Message.success('Password successfully changed')
            }
            resolve(res.data);
          },
          error => {
            Message.warning('Incorrect old password')
            error.changePass = true
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    report({ dispatch, commit, state }, { type, data } ) {
      // console.log("report type...", type);
      // console.log("report data...", data);
      return new Promise((resolve, reject) => {

        var url = API.endpoints.careplan + "/" + state.brand.brand_default_groups.report_concern + "/item";
        var param = {
            "cover_photo"       : new Array(),
            "day"               : 0,
            "timing"            : new Array(),
            "recurrence"        : new Array(),
            "points"            : 1,
            "title"             : 'Reported by: ' + state.info.display_name,
            "activity_name"     : 'Report Concern',
            "highlight"         : false,
            "future_view"       : false,
            "instruction"       : null,
            "data_type"         : 'content',
            "type"              : type,
            "tags"              : new Array(),
            "source_link"       : null,
            "data"              : data,
            "display_mode"      : 'SHOW_FUTURE',
            "is_promo"          : false,
            "privacy"           : 0,
            "enable_user_action": false,
            "persist"           : false,
            "show_alert"        : true,
            "show_dashboard"    : true,
            "preview_text"      : "Coming on $date",
            "order"             : 1
        };
        if (type=='concern' || type=='suggestion' || type=='hero') {
          param = data;
        }

        // console.log('reporting data...', param);
        // return;

        commit('setLoadingReporting', true);
        console.log(param);
        Axios.post(url, param).then(
          res => {
            commit('setLoadingReporting', false);
            resolve(res.data);
            console.log("successfully reported...");
          },
          error => {
            commit('setLoadingReporting', false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    reporting({ dispatch, commit, state }, { type, data }) {
      console.log("reporting...",[{ type, data}]);
      return dispatch('report', { type:type, data:data });
    },
    reportConcern({ dispatch, commit, state }, data ) {
      return dispatch('report', { type:'concern', data:data });
    },
    reportHero({ dispatch, commit, state }, data ) {
      return dispatch('report', { type:'hero', data:data });
    },
    suggestionBox({ dispatch, commit, state }, data ) {
      return dispatch('report', { type:'suggestion', data:data });
    },
    reportOld({ dispatch, commit, state }, v) {
      return new Promise((resolve, reject) => {
        var url = API.endpoints.careplan + "/" + Cons[0].GROUP_ID.report + "/item";
        var param = {
            "cover_photo"       : new Array(),
            "day"               : 0,
            "timing"            : new Array(),
            "recurrence"        : new Array(),
            "points"            : 1,
            "title"             : 'Reported by: ' + v.display_name,
            "activity_name"     : 'Report Concern',
            "highlight"         : false,
            "future_view"       : false,
            "instruction"       : null,
            "data_type"         : 'content',
            "type"              : 'report',
            "tags"              : new Array(),
            "source_link"       : null,
            "data"              : {
              report_type: v.report_type,
              reason: v.reason,
              item_type: v.item_type,
              item_id: state.reportThisId
            },
            "display_mode"      : 'SHOW_FUTURE',
            "is_promo"          : false,
            "privacy"           : 0,
            "enable_user_action": false,
            "persist"           : false,
            "show_alert"        : true,
            "show_dashboard"    : true,
            "preview_text"      : "Coming on $date",
            "order"             : 1
        };
        commit('base/setLoadingPage', true, {root:1});
        Axios.post(url, param).then(
          res => {
            commit('base/setLoadingPage', false, {root:1});
            resolve(res.data);
          },
          error => {
            commit('base/setLoadingPage', false, {root:1});
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    updateUserAvatar({ dispatch, commit, state }, payload) {
      commit('setLoadingUserAvatar', true);
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.user + "/changeavatar", payload).then(
          res => {
            commit('setLoadingUserAvatar', false);
            // do not call updateUserAvatar right after response to prevent 403 images
            // commit("updateUserAvatar", res.data.avatar);
            resolve(res.data);
          },
          error => {
            commit('setLoadingUserAvatar', false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    declinePrescription ({commit, dispatch, state}, {item}) {
      return new Promise((resolve, reject) => {
        Axios.delete(API.endpoints.careplan + '/' + item.id + '/remove').then(
          res => {
            for (var x = 0; x < state.invitations.prescription.careplans.length; x++) {
              if (item.id === state.invitations.prescription.careplans[x].id) {
                state.invitations.prescription.careplans.splice(x, 1)
                break
              }
            }
            Message.success('Decline invitation')
            resolve(item)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          })
      })
    },
    acceptPrescription ({commit, dispatch, state}, {item}) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.careplan + '/' + item.id + '/accept').then(
          res => {
            if (state.invitations.prescription.careplans) {
              for (var x = 0; x < state.invitations.prescription.careplans.length; x++) {
                if (item.id === state.invitations.prescription.careplans[x].id) {
                  state.invitations.prescription.careplans.splice(x, 1)
                  break
                }
              }
            }
            Message.success('Accepted invitation')
            resolve(item)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          })
      })
    },
    declineInvitation ({commit, dispatch}, {item}) {
      return new Promise((resolve, reject) => {
        Axios.delete(API.endpoints.staff + '/invite/' + item.id + '/accept').then(
          res => {
            Message.error('Declined invitation')
            resolve(item)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          })
      })
    },
    acceptInvitation ({commit, dispatch}, {item}) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.staff + '/invite/' + item.id + '/accept').then(
          res => {
            Message.success('Accepted invitation')
            resolve(item)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          })
      })
    },
    getUserGroupInvitation ({commit, dispatch}, {id}) {
      return new Promise((resolve, reject) => {
        commit('setInvitationsLoader', true)
        Axios.get(API.endpoints.journal + '/' + id + '/careplans/pending').then(
          res => {
            commit('setPrescription', res.data)
            commit('setInvitationsLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setInvitationsLoader', false)
            reject(error)
          }
        )
      })
    },
    getUserPendingInvitation ({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        commit('setInvitationsLoader', true)
        Axios.get(API.endpoints.staff + '/user/invites').then(
          res => {
            commit('setInvitations', res.data)
            commit('setInvitationsLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setInvitationsLoader', false)
            reject(error)
          }
        )
      })
    },
    getJournalFeed ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        commit('setUserJournalFeedLoader', true)
        commit('setCountFeedList',0);
        Axios.get(API.endpoints.careplan + "/" + state.info.careplan_id + "/item?asc=0&sort_by=rrule_parsed_date").then(
          res => {
            commit('setCountFeedList',res.data.total);
            commit('setUserJournalFeed', res.data)
            commit('setUserJournalFeedLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setCountFeedList',0);
            commit('setUserJournalFeedLoader', false)
            reject(error)
          }
        )
      })
    },
    getPublicJournalFeed({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        commit('setUserJournalFeedLoader', true)
        commit('setCountFeedList',0);
        Axios.get(API.endpoints.careplan + "/" + state.publicProfile.careplan_id + '/item?asc=0&sort_by=rrule_parsed_date').then(
          res=> {
            commit('setCountFeedList',res.data.total);
            commit('setUserJournalFeed', res.data)
            console.log('getPublicJournalFeed...', res.data);
            commit('setUserJournalFeedLoader', false)
            resolve(res.data)
          },
          error=> {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setCountFeedList',0);
            commit('setUserJournalFeedLoader', false)
            reject(error)
          }
        )
      });
    },
    getJournalFeedMore ({ commit, dispatch, state }, { url }) {
      return new Promise((resolve, reject) => {
        commit('setUserJournalFeedLoader', true)
        Axios.get(url).then(
          res => {
            commit('setUserJournalFeedMore', res.data)
            commit('setUserJournalFeedLoader', false)
            resolve(res.data)
          },
          error => {
            commit('setUserJournalFeedLoader', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getMyStuffMore({ commit, dispatch }, { url }) {
      return new Promise((resolve, reject) => {
        commit('setStuffLoader', true)
        Axios.get(url).then(
          res => {
            commit('setStuffMore', res.data)
            commit('setStuffLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setStuffLoader', false)
            reject(error)
          }
        )
      })
    },
    getUserFeedMore ({ commit, dispatch, state }, { url }) {
      return new Promise((resolve, reject) => {
        commit('setUserFeedLoader', true)
        Axios.get(url).then(
          res => {
            commit('setUserFeedMore', res.data)
            commit('setUserFeedLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setUserFeedLoader', false)
            reject(error)
          }
        )
      })
    },
    getLatestUserFeed ({ commit, dispatch, state }, {startDate}) {
      if( !localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') ) return false;

      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.user + '/careplan/items?direction=up&start_date=' + startDate, {headers: {
          'Cache-Control': 'no-cache' }}).then( res => {
            resolve(res.data)
          }, error => {
            reject(error)
          })
      })
    },
    getUserFeed ({ commit, dispatch, state, rootState }) {
      if( !localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') ) return false;

      return new Promise((resolve, reject) => {
        commit('setUserFeedLoader', true)
        Axios.get(API.endpoints.user + '/careplan/items?brand_id=' + Cons[0].BRAND_ID, {
          'axios-retry': {
            retries: 3
          },
          headers: {
          'Cache-Control': 'no-cache'
          }}).then(
          res => {
            commit('setUserFeed', res.data)
            commit('setUserFeedLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setUserFeedLoader', false)
            reject(error)
          }
        )
      })
    },
    getSingleUserFeed({}) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.user + '/careplan/items?per_page=1&brand_id=' + Cons[0].BRAND_ID)
          .then(res => resolve(res.data),
          error => reject(error))
      })
    },
    setBrandingPrescription ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        let mCookie = VueCookie.get(Cons[0].PATHS.NAME + 'PRESCRIPTION')
        let prescription = JSON.parse(mCookie)

        if (prescription) {
          commit('base/setLoadingPage', true, {root: 1})
          Axios.put(API.endpoints.prescription + '/' + prescription, {is_accepted: 1}).then(
            res => {
              VueCookie.delete(Cons[0].PATHS.NAME + 'PRESCRIPTION')
              commit('base/setLoadingPage', false, {root: 1})
              dispatch('getUserInfo')
            },
            error => {
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              commit('base/setLoadingPage', false, {root: 1})
              reject(error)
            }
          )
        }
      })
    },
    acceptPlanPrescription ({ commit, dispatch, state }, {code}) {
      return new Promise((resolve, reject) => {
        commit('base/setLoadingPage', true, {root: 1})
        Axios.post(API.endpoints.careplan + '/' + code + '/accept').then(
          res => {
            VueCookie.delete(Cons[0].PATHS.NAME + 'PLAN_PRESCRIPTION')
            commit('base/setLoadingPage', false, {root: 1})
          }, error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('base/setLoadingPage', false, {root: 1})
            reject(error)
          })
      })
    },
    setUserSetup(context, payload) {
      if(payload.user_type === 'member') {
        context.dispatch('brand/getBrandStories', Cons[0].BRAND_ID, {root: 1})
          .then(res => {
            if ( VueCookie.get("PRESCRIPTION_GROUP") ) {
              context.dispatch("base/onRegisterUserStory", {
                userStory: VueCookie.get("PRESCRIPTION_GROUP"),
                slug: router.history.current.params.brandSlug
              }, {root:1});
            }
          })

        context.dispatch('getUserManageBrands')
        context.dispatch('menu/getPermittedPlan', null, { root: 1 })

        if (router.history.current.name === 'HomePage') {
          context.dispatch('getUserGroupInvitation', {id: payload.journal_id})
          context.dispatch('getUserPendingInvitation')
        }

        context.commit('setInfoLoader', false);
      } else {
        context.dispatch('brand/getBrandStories', Cons[0].BRAND_ID, {root: 1})
          .then(res => {
            if ( VueCookie.get("PRESCRIPTION_GROUP") ) {
              context.dispatch("base/onRegisterUserStory", {
                userStory: VueCookie.get("PRESCRIPTION_GROUP"),
                slug: router.history.current.params.brandSlug
              }, {root:1});
            }
          })
      }
    },
    getUser({}) {
      return Axios.get(API.endpoints.me, {
          'axios-retry': {
            retries: 3
          }
        }).then(res => Promise.resolve(res), error => Promise.reject(error))
    },
    async getUserInfo ({ commit, dispatch, state }) {
      return await new Promise((resolve, reject) => {
        commit('setInfoLoader', true)
        commit('base/setLoadingPage', true, {root:1})
        commit('base/setUserAuthLoader', true, {root:1});

        dispatch('getUser')
          .then(
            me => {
              commit('setUserInfo', me.data)

              if ( router.currentRoute.name != 'Brand Preview' && router.currentRoute.name != 'Preview') {
                dispatch('points/getCurrentUserPoints', me.data.journal_id, {root:1});
                dispatch('points/getUserActions', null, {root:1});
              }
                
              setTimeout(() => {
                if ( router.currentRoute.name != 'Brand Preview' && router.currentRoute.name != 'Preview') {
                  dispatch('getActionMenu', null, {root:1});
                }
              }, 2000);

              if( "brandSlug" in router.currentRoute.params && router.currentRoute.params.brandSlug ) {
                dispatch("getUserBrandInfo", router.currentRoute.params.brandSlug)
                  .then( res => {
                    if ( router.currentRoute.name != 'Brand Preview' && router.currentRoute.name != 'Preview') {
                      dispatch('feature/getFeaturedActivity', null, {root: 1});
                      dispatch('brand/getUserBrands', me.data.id, {root: 1});
                      dispatch('getUserFeed');
                      dispatch('setUserSetup', me.data);
                      dispatch('packages/getPackage', res, {root: 1})
                        .then(packages => {
                          if (packages.data.user_story)
                            dispatch('packages/getStories', null, {root: 1})
                          commit('base/setLoadingPage', false, {root:1})
                          commit('base/setUserAuthLoader', false, {root:1});
                        })
                        .catch( error => {
                          commit('base/setLoadingPage', false, {root:1})
                          commit('base/setUserAuthLoader', false, {root:1});
                        })
                    } else {
                      commit('base/setLoadingPage', false, {root:1})
                      commit('base/setUserAuthLoader', false, {root:1});
                    }
                  });
              } else {
                console.log("Default")
                dispatch('getUserBrandInfo')
                dispatch('brand/getAppBrand', null, {root: 1})
                .then(brand => {

                  if ( router.currentRoute.name != 'Brand Preview' && router.currentRoute.name != 'Preview') {
                    console.log(brand);
                    dispatch('getUserFeed');
                    dispatch('setUserSetup', me.data);
                    dispatch('brand/getUserBrands', me.data.id, {root: 1});
                    dispatch('packages/getPackage', brand, {root: 1})
                      .then(packages => {
                        if (packages.data.user_story)
                          dispatch('packages/getStories', null, {root: 1})
                        commit('base/setLoadingPage', false, {root:1})
                        commit('base/setUserAuthLoader', false, {root:1});
                      })
                      .catch( error => {
                        commit('base/setLoadingPage', false, {root:1})
                        commit('base/setUserAuthLoader', false, {root:1});
                      })
                  } else {
                    commit('base/setLoadingPage', false, {root:1})
                    commit('base/setUserAuthLoader', false, {root:1});
                  }
                })
              }

              if (me.data.user_type != "guest" &&
                _.get(me, "data.email") &&
                me.data.email.length === 0 &&
                _.get(me, "data.mobile") &&
                me.data.mobile.length === 0
              ) {
                router.replace("/onboarding");
              }
              
              dispatch("library/getUserStories", Cons[0].BRAND_ID, {root:1})
              resolve(me.data)
            },
            error => {
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              commit('setInfoLoader', false)
              reject(error)
            }
          )
      })
    },
    getCarePlanItems({ commit, dispatch, state }) {
      if( !localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') ) return false;

      return new Promise((resolve, reject) => {
        var param = { per_page:50, page: 1 };
        Axios.get(API.endpoints.user+"/careplan/items", param).then(
          res=> {
            console.log("carePlanItems...");
            console.log(res.data);
            commit('setUserJournalFeed', res.data);
            // commit('setUserJournalFeedMore', res.data)
          },
          error=> {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      });
    },
    getPublicProfile ({ commit, dispatch, state }, profileId) {
      return new Promise((resolve, reject) => {
        commit('base/setLoadingPage', true, { root: 1 })
        Axios.get(API.endpoints.user + '/' + profileId, {
          headers: {
            'Cache-Control': 'no-cache'
          }
        }).then(
          res => {
            commit('setPublicProfile', res.data)
            commit('base/setLoadingPage', false, { root: 1 })
            resolve(res.data)
          },
          error => {
            commit('base/setLoadingPage', false, { root: 1 })
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    deleteItem (context, payload) {
      let id = context.rootState.user.info.careplan_id;
      let url = `${API.endpoints.careplan}/${id}/item/${payload}`;
      console.log("url...",url);
      return Axios.delete(url);
    },
    setPublicProfileBookmark ({ commit, dispatch, rootState }) {
      return new Promise((resolve, reject) => {
        let user = rootState.publicProfile.info.data;
        let isBookmarked = user.bookmarked;
        let method = isBookmarked ? 'delete' : 'post';
        let bookmark_id = user.hasOwnProperty('bookmark_id')?user.bookmark_id: '';
        let url = API.endpoints.bookmark + (isBookmarked ? '/' + bookmark_id : '')
        let data = isBookmarked
          ? '{}'
          : { item_id: user.id, type: 'person' }

        console.log('setPublicProfileBookmark url...', url);
        console.log('setPublicProfileBookmark data...', data);

        commit('setIsLoadingBookmark', true)
        Axios({ method: method, url: url, data: data }).then(
          res => {
            commit('setPublicProfileBookmark', isBookmarked ? 0 : 1)
            commit('setIsLoadingBookmark', false)
            if (!isBookmarked) {
              commit('setBookmarkId', res.data.id)
            }
            resolve(res.data)
          },
          error => {
            commit('setIsLoadingBookmark', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    setPublicProfileBookmark1 ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        var isBookmarked = state.publicProfile.bookmarked
        var method = isBookmarked ? 'delete' : 'post'
        var url =
          API.endpoints.bookmark +
          (isBookmarked ? '/' + state.publicProfile.bookmark_id : '')
        var data = isBookmarked
          ? '{}'
          : { item_id: state.publicProfile.id, type: 'person' }
          console.log('setPublicProfileBookmark url...', url);
          console.log('setPublicProfileBookmark data...', data);

        commit('setIsLoadingBookmark', true)
        Axios({ method: method, url: url, data: data }).then(
          res => {
            commit('setPublicProfileBookmark', isBookmarked ? 0 : 1)
            commit('setIsLoadingBookmark', false)
            if (!isBookmarked) {
              commit('setBookmarkId', res.data.id)
            }
            resolve(res.data)
          },
          error => {
            commit('setIsLoadingBookmark', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserBrandInfo ({ dispatch, commit, state }, payload) {
      let url = API.endpoints.brand + '/'

      if ('branding_doctor_id' in state.info && state.info.branding_doctor_id) {
        url += state.info.branding_doctor_id
      } else {
        url += '1'
      }

      if ( payload ) {
        state.loadingBrandingData = true;
        return new Promise((resolve, reject) => {
          commit('setIsLoadingBrandInfo', true)
          Axios.get(API.endpoints.base + "/doctor/" + payload, {
            'axios-retry': {
              retries: 3
            }
          }).then(
            res => {
              if ( window.idle ) window.idle.stop();
              if ( res.data.auto_logout.enabled)
                window.idleTimeUpdate(res.data.auto_logout)

              // commit("setIdleTimer", res.data.auto_logout, { root: 1});
              VueCookie.set("CURRENT_BRAND_SLUG", JSON.stringify(res.data.unique_identifier))
              localStorage.setItem(Cons[0].PATHS.NAME + "THEME", JSON.stringify(res.data.theme))
              Cons[0].BRAND_ID = res.data.id

              if (res.data.resource_id) {
                if (res.data.resource_id.about_app) {
                  Cons[0].MENU_COMPONENT.about_us = res.data.resource_id.about_app
                }
                if (res.data.resource_id.about_us) {
                  Cons[0].MENU_COMPONENT.about_sharpen = res.data.resource_id.about_us;
                }
                if (res.data.resource_id.contact_us){
                  Cons[0].MENU_COMPONENT.contact_us = res.data.resource_id.contact_us;
                }
              }
              dispatch("resource/getDiscover", {}, { root: 1 })
              console.log('res.datazzzz',res.data);
              if(res.data.resource_id.contacts && res.data.resource_id.contacts.length > 0){
                dispatch('getItemsInRange', res.data.resource_id.contacts)
              }
              commit('setUserBrand', res.data)
              dispatch('getUserBrandPlan', { id: res.data.careplan_id })
              commit('setIsLoadingBrandInfo', false)
              state.loadingBrandingData = false;
              dispatch('getBrandCategoriesItem',{globalResourceId:res.data.global_resource, networkResourceId:res.data.network_resource, resourceId:res.data.resource_id})
              resolve(res.data)
            },
            error => {
              state.loadingBrandingData = false;
              commit('setIsLoadingBrandInfo', false)
              router.replace("/"+process.env.VUE_APP_DEV_ECOSYSTEM);
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        });
        return false;
      }

      return new Promise((resolve, reject) => {
        commit('setIsLoadingBrandInfo', true)
        Axios.get(url).then(
          res => {
            commit('setUserBrand', res.data)
            dispatch('getBrandActionMenu', {
              brand_id: Cons[0].BRAND_ID
            })
            dispatch('getUserBrandPlan', { id: res.data.careplan_id })
            commit('setIsLoadingBrandInfo', false)
            resolve(res.data)
          },
          error => {
            commit('setIsLoadingBrandInfo', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    async getBrandActionMenu(context, payload) {
      try {
        let response = await Axios.get(`${API.endpoints.base}brand/${payload.brand_id}/menu/items?group_type=do_action_menu`, {
          'axios-retry': {
            retries: 3
          }
        })
        return response.data
      } catch (e) {
        console.log(e)
        return e
      }
    },
    getUserBrandPlan ({ dispatch, commit, state }, { id }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + id).then(
          res => {
            commit('setUserBrandPlan', res.data)
            resolve(res.data)
          },
          error => {
            reject(error)
          }
        )
      })
    },
    unfollowGroup ({ dispatch, commit, state }, id) {
      return new Promise((resolve, reject) => {
        Axios.delete(API.endpoints.careplan + "/" + id + "/unsubscribe")
          .then(res => {
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    followGroups ({ dispatch, commit, state }, {ids}) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.base + '/follow/group', {group_id:ids}).then(
          res => {
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getAllSkills ({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.developedPlans + '?per_page=50&group_id=1&type=skill&section=group').then(
          res => {
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getAllAdvocacies ({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.developedPlans + '?per_page=50&group_id=1&type=interest&section=group').then(
          res => {
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getAdvocacies ({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.developedPlans + '?group_id=1&type=interest&section=group&published=1').then(
          res => {
            commit('setAdvocacies', res.data);
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getResourceByTypeOnboarding ({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.base}/brand/${Cons[0].BRAND_ID}/interest`).then(
          res => {
            // commit('setResourcesByType', {data: res.data, type});
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getResourceByType ({ dispatch, commit, state }, {type}) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.developedPlans + '?group_id='+Cons[0].BRAND_ID+'&type='+type+'&access=public&section=group&published=1&per_page=30').then(
          res => {
            commit('setResourcesByType', {data: res.data, type});
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getResourceInterest ({ dispatch, commit, state }, {type}) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.developedPlans + '?group_id=1&type='+type+'&section=group&published=1&sort_by=is_featured&asc=0&per_page=30').then(
          res => {
            commit('setResourcesByType', {data: res.data, type});
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getPendingAdvocacies ({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.developedPlans + '?group_id=1&type=interest&section=group&publish=0').then(
          res => {
            commit('setPendingAdvocacies', res.data);
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserFields ({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.profile + '/fields').then(
          res => {
            commit('setUserFields', res.data);
            commit('onBoarding/setUserFields', res.data, {root:1});
            resolve(res.data)
          },
          error => {
            reject(error)
          }
        )
      })
    },
    updateUserInfo ({ dispatch, commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setIsLoadingUserProfile', true)
        Axios.put(API.endpoints.user + '/' + payload.id, payload.data).then(
          res => {
            commit('setUserInfo', {...state.info,...res.data});
            commit('setIsLoadingUserProfile', false)
            Message.success("Profile Info Updated");
            resolve(res.data)
          },
          error => {
            commit('setIsLoadingUserProfile', false)
            reject(error)
          }
        )
      })
    },
    updateUserInfo ({ dispatch, commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setIsLoadingUserProfile', true)
        Axios.put(API.endpoints.user + '/' + payload.id, payload.data).then(
          res => {
            commit('setUserInfo', {...state.info,...res.data});
            commit('setIsLoadingUserProfile', false)
            Message.success("Profile Info Updated");
            resolve(res.data)
          },
          error => {
            commit('setIsLoadingUserProfile', false)
            reject(error)
          }
        )
      })
    },
    getImageLibraries({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.base + '/image/libraries?app=' + process.env.VUE_APP_AVATAR_LIBRARY_SLUG).then(
          res => {
            commit('setImageLibraries', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    changeAvatar({ dispatch, commit, state }, { newAvatar }) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.user + '/changeavatar', {
          avatar: newAvatar
        }).then(
          res2 => {
            Vue.set(state.info, 'avatar', res2.data.avatar)
            commit('base/setLoadingPage', false, { root: 1 })
            // router.go(-1);
            resolve(res2.data)
          },
          error => {
            commit('base/setLoadingPage', false, { root: 1 })
            // router.replace('/home')
            // dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    } ,
    saveOnboardingData ({ dispatch, commit }, { data, newAvatar }) {
       return new Promise((resolve, reject) => {
        commit('base/setLoadingPage', true, { root: 1 })

        if(newAvatar) {
          dispatch('changeAvatar', {newAvatar})
            .then(avatarRes => {
              commit('updateUserAvatarUri', avatarRes.avatar_uri)
            })
        }

        Axios.put(API.endpoints.user + '/' + data.id, data).then(
          res => {
            commit('setUserInfo', res.data)
            if(!newAvatar) {              // router.go(-1);
              commit('base/setLoadingPage', false, { root: 1 })
            }
            resolve(res.data)
          },
          error => {
            reject(error)
            commit('base/setLoadingPage', false, { root: 1 })
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
          }
        )
      })
    },
    getUserBookmarks ({ dispatch, commit, state }, {id}) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.bookmark + '?user_id='+id+'&asc=0').then(
          res => {
            commit('setUserBookmark', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserStuffs ({ dispatch, commit, state }, payload) {
      return new Promise((resolve, reject) => {
        if (state.info.journal_id !== payload) {
          commit('setUserStuffs', []);
        }
        commit('setLoadingUserStuffs', true);
        commit('setCountUserStuffs',0);
        Axios.get(API.endpoints.journal + '/' + payload + '/careplans?sort_by=updated_at').then(
          res => {
            commit('setCountUserStuffs',res.data.total);
            commit('setUserStuffs', res.data);
            commit('setLoadingUserStuffs', false);
            resolve(res.data);
          },
          error => {
            commit('setCountUserStuffs',0);
            commit('setLoadingUserStuffs', false);
            dispatch('exceptionHandling', { _err: error }, { root: 1 });
            reject(error);
          }
        )
      })
    },
    serachUserStuffs ({ dispatch, commit, state }, payload) {
      commit('setLoadingSearch', true)
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.journal + '/' + payload.journal_id + '/careplans?sort_by=updated_at&search=' + payload.search).then(
          res => {
            commit('setUserStuffs', res.data)
            commit('setLoadingSearch', false)
            resolve(res.data)
          },
          error => {
            commit('setLoadingSearch', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    loadMore ({ dispatch, commit, state }, payload) {
      commit('setLoadingLoadMore', true)
      return new Promise((resolve, reject) => {
        Axios.get(payload.link).then(
          res => {
            if (payload.type === 'bookmark') {
              commit('pushUserBookmarks', res.data)
            } else if (payload.type === 'stuffs') {
              commit('pushUserStuffs', res.data)
            }
            commit('setLoadingLoadMore', false)
            resolve(res)
          },
          error => {
            commit('setLoadingLoadMore', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserManageBrands ({ dispatch, commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setUserManageBrandLoading', true)
        Axios.get(API.endpoints.user + '/doctors').then(
          res => {
            commit('setUserManageBrand', res.data)
            commit('setUserManageBrandLoading', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setUserManageBrandLoading', false)
            reject(error)
          }
        )
      })
    },
    setLocation({ dispatch, commit }, payload) {
      commit("setLocationLoader", true);
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.checkin, payload).then(
          res => {
            console.log(res.data.category);
            if (res.data.category == "work")
              commit("setWorkLocation", res.data);
            else if (res.data.category == "home")
              commit("setHomeLocation", res.data);
            resolve(res.data);
            commit("setLocationLoader", false);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            commit("setLocationLoader", false);
            reject(error);
          }
        );
      });
    },
    getCountryProvinceCity({state,commit, dispatch}) {
      return new Promise((resolve, reject) => {
      Axios.get(API.endpoints.journal + '/' + state.info.journal_id + '/careplans?sort_by=updated_at&type=city,province,country')
        .then(res => {
          if(res.data.careplans[0]) {
            for (var x = 0; x < res.data.careplans.length; x++) {
              if(res.data.careplans[x].careplan.type == 'country'){
                commit('setNearbyCountry', res.data.careplans[x].careplan)
              }else if(res.data.careplans[x].careplan.type == 'province'){
                commit('setNearbyProvince', res.data.careplans[x].careplan)
              }else if(res.data.careplans[x].careplan.type == 'city'){
                commit('setNearbyCity', res.data.careplans[x].careplan)
              }
            }
            resolve(res.data.careplans[0])
          }
        },error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 });
          reject(error);
        })
      });
    },
    getDocuments({state,commit,dispatch}){
      commit('isDocumentsLoading', true)
      console.log(state.info.careplan_id);
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + state.info.careplan_id + '/item?exclude_type=gallery&asc=0&sort_by=rrule_parsed_date&type=document')
        .then(res=>{
          commit('setDocuments', res.data)
          commit('isDocumentsLoading', false)
          resolve(res.data)
        }, error => {
          commit('isDocumentsLoading', false)
          dispatch('exceptionHandling', { _err: error }, { root: 1 });
          reject(error);
        })
      })
    },
    getDocumentCategory({state, commit, dispatch}){
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.field + '/document_category')
        .then(res=>{

          res.data.choices.push({
            label: "Other",
            value: "other",
            order: 5
          })

          commit('setDocumentCategoryChoices', res.data.choices)
          // commit('isDocumentsLoading', false)
          resolve(res.data)
        }, error => {
          // commit('isDocumentsLoading', false)
          dispatch('exceptionHandling', { _err: error }, { root: 1 });
          reject(error);
        })
      })
    },
    getUserItemByType({state,commit,dispatch}, type){
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + state.info.careplan_id + '/item?exclude_type=gallery&asc=0&sort_by=rrule_parsed_date&type=' + type)
        .then(res=>{
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 });
          reject(error);
        })
      })
    },
    getCareteam(context, payload) {
      return new Promise((resolve, reject) => {
        context.state.isLoadingCareteam = true;

        let url = `${API.endpoints.careplan}/${payload.id}/subscribers?sort_by=latest&type=member,group`;

        if (payload.key)
          url += `&search=${payload.key}`

        Axios.get(url)
          .then(res => {
            context.state.isLoadingCareteam = false;
            context.state.careteam = res.data;
            resolve(res.data);
          }, error => {
            context.state.isLoadingCareteam = false;
            reject(error);
          }
        );
      });
    },
    getBrandUsers(context, payload) {
      return new Promise((resolve, reject) => {
        context.state.isLoadingBrandUsers = true;

        let url = `${API.endpoints.careplan}/${context.state.brand.careplan_id}/subscribers?sort_by=latest&brand_id=${Cons[0].BRAND_ID}`;

        if (payload.key)
          url += `&search=${payload.key}`

        Axios.get(url)
          .then(res => {
            context.state.isLoadingBrandUsers = false;
            resolve(res.data);
          }, error => {
            context.state.isLoadingBrandUsers = false;
            reject(error);
          }
        );
      });
    },
    addCareteam(context, payload) {
      return new Promise((resolve, reject) => {
        context.state.isLoadingAddCareteam = true;
        Axios.post(`${API.endpoints.careplan}/prescribe`, payload)
          .then(res => {
            context.state.isLoadingAddCareteam = false;
            resolve(res.data);
          }, error => {
            context.state.isLoadingAddCareteam = false;
            reject(error);
          }
        );
      });
    },
    kickCareteam(context, payload) {
      return new Promise((resolve, reject) => {
        context.state.isLoadingKickCareteam = true;
        Axios.delete(`${API.endpoints.careplan}/${payload}/remove`)
          .then(res => {
            console.log('find', res.data);
            
            context.state.isLoadingKickCareteam = false;
            resolve(res.data);
          }, error => {
            context.state.isLoadingKickCareteam = false;
            reject(error);
          }
        );
      });
    },
    getUserCareTeamGroups(context, payload) {
      return new Promise((resolve, reject) => {
        context.state.isLoadingCareteamGroup = true;
        context.commit("base/setLoadingPage", true, {root:1})
        Axios.get(`${API.endpoints.base}/journal/${payload}/careplans?type=private_journal`)
          .then(res => {
            context.state.isLoadingCareteamGroup = false;
            context.commit("base/setLoadingPage", false, {root:1})
            context.state.careteamgroups = res.data
            
            resolve(res.data);
          }, error => {
            context.state.isLoadingCareteamGroup = false;
            context.commit("base/setLoadingPage", false, {root:1})
            reject(error);
          }
        );
      });
    },
    getActivityInfo(context, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.item}/${payload}`)
          .then(res => {
            resolve(res.data);
          }, error => {
            reject(error);
          }
        );
      });
    },
    getItemsInRange(context,payload){
      let arrayIds = '';
      payload.forEach((contact,index) => {
        console.log(contact.phone);
        arrayIds += contact.phone + ((payload.length == index + 1) ? '' : ',')
      });  
      if(!arrayIds)return;
      return new Promise((resolve, reject)=>{
        Axios.get(`${API.endpoints.itemsRange}?item_id=${arrayIds}&order=0`)
          .then(res => {
            context.commit('setBrandContacts',res.data)
            resolve(res.data);
          },err =>{
            reject(err);
          });
      });
    },
    getBrandConsent({state, commit, dispatch},payload){
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.base}user/${payload.user_id}/concent?brand_id=${payload.brand_id}`)
          .then(res => {
            commit('setConsent', res.data)
            resolve(res.data);
          }, error => {
            reject(error);
          }
        );
      });
    },
    saveBrandConsent({state, commit, dispatch},payload){
      return new Promise((resolve, reject) => {
        Axios.post(`${API.endpoints.base}user/concent`, payload)
          .then(res => {
            commit('setConsent', res.data)
            resolve(res.data);
          }, error => {
            reject(error);
          }
        );
      });
    },
    getBrandCategoriesItem({state,commit,dispatch},payload){
      let cope    = payload.resourceId.cope     || payload.networkResourceId.cope     || payload.globalResourceId.cope
      let heal    = payload.resourceId.heal     || payload.networkResourceId.heal     || payload.globalResourceId.heal
      let thrive  = payload.resourceId.thrive   || payload.networkResourceId.thrive   || payload.globalResourceId.thrive
      let nourish = payload.resourceId.nourish  || payload.networkResourceId.nourish  || payload.globalResourceId.nourish
      if(cope){
        dispatch('feed/getSingleItem', cope, {root:1})
          .then(res=>{
            state.brandCategory.cope = res.data
          }
        );
      }else if(!cope){
        state.brandCategory.cope = null
      }

      if(thrive){
        dispatch('feed/getSingleItem', thrive, {root:1})
          .then(res=>{
            state.brandCategory.thrive = res.data
          }
        );  
      }else if(!thrive){
        state.brandCategory.thrive = null
      }

      if(heal){
        dispatch('feed/getSingleItem', heal, {root:1})
          .then(res=>{
            state.brandCategory.heal = res.data
          }
        );
      }else if(!heal){
        state.brandCategory.heal = null
      }

      if(nourish){
        dispatch('feed/getSingleItem', nourish, {root:1})
          .then(res=>{
            state.brandCategory.nourish = res.data
          }
        );  
      }else if(!nourish){
        state.brandCategory.nourish = null
      }
    }
  }
}
